import sendBasketReq from './helpers/basketFetch';

const scriptsInit = () => {
  window.popupsInit();
};

const clearBasketHandler = async (evt) => {
  evt.stopPropagation();

  const formData = new FormData();
  formData.append('action', 'clear-basket');
  formData.append('sessid', window.localStorage.getItem('phpSessId'));

  const response = await sendBasketReq(formData);
  const parentContainer = document.getElementById('basket-container').parentNode;

  if (parentContainer && response) {
    parentContainer.innerHTML = response;
    scriptsInit();
  }

  window.popupClose(evt.target.closest('#clean-cart'));
};

const init = () => {
  const clearBasketButton = document.querySelector('[data-basket-button="clearBasketButton"]');

  if (clearBasketButton && !clearBasketButton.classList.contains('_init')) {
    clearBasketButton.addEventListener('click', clearBasketHandler);

    clearBasketButton.classList.add('_init');
  }
};

init();

window.initClearBasketItem = init;
